export default "__VITE_ASSET__NYjWoo7t__"